import {
    apiRequest,
    refBknJabatanTertentuList,
    syncDataBknJabatanTertentu
} from "../../../../../../services/adapters/master/refBknJabatanTertentuService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", refBknJabatanTertentuList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchSyncData = async (query, cancelToken) => {
        return await apiRequest("get", syncDataBknJabatanTertentu, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
}

export default DataTableRepository